import { RevisionInformationGroupsEnum } from '@acceligentllc/shared/enums/revisionInformationGroups';

export const OUTDATED_INFO_CATEGORIES_ORDERED = [
	RevisionInformationGroupsEnum.JOB,
	RevisionInformationGroupsEnum.CREW_AND_DATE,
	RevisionInformationGroupsEnum.GENERAL,
	RevisionInformationGroupsEnum.LOCATIONS,
	RevisionInformationGroupsEnum.RESOURCES,
	RevisionInformationGroupsEnum.NOTES_1,
	RevisionInformationGroupsEnum.NOTES_2,
];
